
import PropTypes from 'prop-types';

/**
 * PropType matching [[org.coursera.ondemand.content.{Content,PlainTextOrCmlContent}]]s
 * returned by APIs.
 */
export default PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.shape({
    typeName: PropTypes.oneOf(['htmlText']).isRequired,
    definition: PropTypes.shape({
      content: PropTypes.string.isRequired,
    }).isRequired,
  }),
  PropTypes.shape({
    typeName: PropTypes.oneOf(['html']).isRequired,
    definition: PropTypes.string.isRequired,
  }),
  PropTypes.shape({
    typeName: PropTypes.oneOf(['cml']).isRequired,
    definition: PropTypes.shape({
      value: PropTypes.string.isRequired,
    }).isRequired,
  }),
]);
